import { postWithoutToken } from './base';
import constants from '../../config/constants';

export const postWithoutTokenMethod = (endPoint,jsonData) => {
    const url = constants.BASE_URL + endPoint;
    return postWithoutToken(url, { jsonData });
};
